import { mediaGQLFields } from '../media/index.js';
import { networkAuthMemberPropsGQLFields, } from '../permission/index.js';
import { postTypeGQLFields, } from '../post-type/postType.fields.js';
import { navigationSlatesGQLFields, } from '../slate/index.js';
import { spaceGQLFields } from '../space/index.js';
import { newThemesGQLFields, themesGQLFields, } from '../theme/index.js';
import { badgeGQLFields } from './badge.fields.js';
import { customFieldsSchemaGQLFields, } from './customFieldsSchema.fields.js';
import { customCodeGQLFields, topNavigationGQLFields } from './network.gql.js';
import { planGQLFields } from './plan.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_NETWORK_FIELDS = {};
const ALL_NETWORK_FIELDS = {
    activeTheme: 'basic',
    themes: 'basic',
    topNavigation: 'basic',
    logo: 'basic',
    favicon: 'basic',
    whoCanInvite: 'basic',
    defaultSpaces: 'basic',
    roles: 'basic',
    customCode: 'basic',
    authMemberProps: 'basic',
    subscriptionPlan: 'basic',
    systemSpaces: 'basic',
    memberFields: 'basic',
    customSeoDetail: 'basic',
    badges: 'basic',
    limits: 'basic',
    usages: 'basic',
    settings: 'basic',
    postTypes: 'basic',
};
const DEFAULT_NETWORK_FIELDS = {
    authMemberProps: { permissions: 'all' },
    customCode: 'all',
    favicon: 'all',
    logo: 'all',
    roles: 'all',
    navigationSlates: 'all',
    themes: 'all',
    activeTheme: 'all',
    topNavigation: 'all',
    subscriptionPlan: 'all',
    systemSpaces: {
        slate: 'all',
    },
    memberFields: 'all',
    customSeoDetail: 'all',
    badges: 'default',
    settings: 'basic',
    postTypes: {
        icon: 'basic',
        authMemberProps: {
            availableSpaces: {
                image: 'basic',
                authMemberProps: {
                    spaceMember: {
                        role: 'basic',
                    },
                },
            },
        },
        postFields: {
            fields: 'all',
        },
        validReplyTypes: 'basic',
        slate: 'all',
    },
    extraProperties: {
        variables: {},
    },
};
export function networkGQLFields(fields) {
    var _a, _b;
    if (fields === 'basic') {
        fields = BASIC_NETWORK_FIELDS;
    }
    if (fields === 'all') {
        fields = ALL_NETWORK_FIELDS;
    }
    if (fields === 'default') {
        fields = DEFAULT_NETWORK_FIELDS;
    }
    return `
    id
    aliases
    companyName
    name
    description
    visibility
    membership
    logoId
    faviconId
    locale
    availableLocales
    domain
    createdAt
    newDomain
    incidentEmails
    privacyPolicyUrl
    termsOfServiceUrl
    brandColor
    billingEmail
    status
    memberCapacity
    memberCapacityDeclared
    passwordComplexity
    seatsCapacity
    additionalSeatsCapacity
    seatCapacityDeclared
    tribeBranding
    whoCanInviteIds
    hideDefaultAuthenticationForm
    releaseChannel
    domainSubfolder
    landingPages {
      landingPageForGuest
      landingPageForMember
      landingPageForNewMember
    }
    activeSso {
      logoutUrl
      settingsUrl
    }
    ${fields.settings
        ? `
    settings {
      emailEnabled
      emailFrom
      emailNotificationEnabled
      fileSizeLimit
      fileTypesLimit
      imageSizeLimit
      imageTypesLimit
      contentTranslation {
        enabled
      }
      memberPermissions {
        canDeleteAccount
      }
      privateMessaging {
        privateMessagingEnabled
        membersCanUsePrivateMessaging
        membersCanTurnOffPrivateMessaging
      }
    }
    `
        : ``}
    ${fields.limits
        ? `
    limits {
      fileSizeLimit
      fileTypesLimit
      imageSizeLimit
      imageTypesLimit
      analyticsLimits {
        planLimits {
          daysLimitation
          plan
        }
      }
    }
    `
        : ``}
    ${fields.usages
        ? `
    usages {
      fileStorageUsage
      imageStorageUsage
    }
    `
        : ``}
    ${fields.navigationSlates
        ? `
      navigationSlates {
        ${navigationSlatesGQLFields(fields.navigationSlates)}
      }
    `
        : ``}
    ${fields.activeTheme
        ? `
      activeTheme {
        ${newThemesGQLFields(fields.activeTheme)}
      }
    `
        : ``}
    ${fields.themes
        ? `
      themes {
        ${themesGQLFields(fields.themes)}
      }
    `
        : ``}
    ${fields.topNavigation
        ? `
      topNavigation {
        ${topNavigationGQLFields(fields.topNavigation)}
      }
    `
        : ``}
    ${fields.logo
        ? `
      logo {
        ${mediaGQLFields(fields.logo)}
      }
    `
        : ``}
    ${fields.favicon
        ? `
      favicon {
        ${mediaGQLFields(fields.favicon)}
      }
    `
        : ``}
    ${fields.whoCanInvite
        ? `
      whoCanInvite {
        ${roleGQLFields(fields.whoCanInvite)}
      }
    `
        : ``}
    ${fields.defaultSpaces
        ? `
      defaultSpaces {
        ${spaceGQLFields(fields.defaultSpaces)}
      }
    `
        : ``}
    ${fields.roles
        ? `
      roles {
        ${roleGQLFields(fields.roles)}
      }
    `
        : ``}
    ${fields.customCode
        ? `
      customCodes(anonymize: false) {
        ${customCodeGQLFields(fields.customCode)}
      }
    `
        : ``}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${networkAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
    ${fields.subscriptionPlan
        ? `
      subscriptionPlan {
        ${planGQLFields(fields.subscriptionPlan)}
      }
    `
        : ``}
    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${spaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
    ${fields.memberFields
        ? `
      memberFields {
        ${customFieldsSchemaGQLFields(fields.memberFields)}
      }
    `
        : ``}
    ${(fields === null || fields === void 0 ? void 0 : fields.customSeoDetail)
        ? `
      customSeoDetail {
        description
        noIndex
        thumbnail {
          ${mediaGQLFields('basic')}
        }
        thumbnailId
        title
      }
    `
        : ``}
    ${(fields === null || fields === void 0 ? void 0 : fields.extraProperties)
        ? `
      extraProperties ${((_b = (_a = fields === null || fields === void 0 ? void 0 : fields.extraProperties) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.keys)
            ? `(keys: ["${fields.extraProperties.variables.keys.join('","')}"])`
            : ``} {
        key
        value
      }
    `
        : ``}
    ${fields.postTypes
        ? `
      postTypes {
        ${postTypeGQLFields(fields.postTypes)}
      }
    `
        : ``}    
    ${(fields === null || fields === void 0 ? void 0 : fields.badges)
        ? `
      badges {
        ${badgeGQLFields(fields === null || fields === void 0 ? void 0 : fields.badges)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=network.fields.js.map